import { render, staticRenderFns } from "./DisplayCards.vue?vue&type=template&id=22d8b6e2&scoped=true"
import script from "./DisplayCards.vue?vue&type=script&lang=js"
export * from "./DisplayCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d8b6e2",
  null
  
)

export default component.exports